import { FlagProvider } from '@unleash/proxy-client-react';
import React, { useEffect } from 'react';
import { getUnleashClient } from './unleashClient';

declare global {
  interface Window {
    UNLEASH_CLIENT_KEY?: string;
    UNLEASH_APP_NAME?: string;
    UNLEASH_PROXY_URL?: string;
    UNLEASH_REFRESH_INTERVAL?: string;
  }
}

interface Props {
  children: React.ReactNode;
}

let started = false;
/**
 * Note that the "loaded" status of flags will never complete in other
 * providers due to `startClient={false}` being passed.
 * If the loaded state is required use the event listeners in the client found
 * here: https://github.com/Unleash/unleash-proxy-client-js
 */
export const ProvideFeatureFlags = ({ children }: Props) => {
  const client = getUnleashClient();

  // Idempotently start global client so that re-mounting the provider doesn't
  // log errors.
  useEffect(() => {
    if (!started) {
      client?.start();
      started = true;
    }
  }, []);

  return (
    <>
      {client && (
        <FlagProvider unleashClient={client} startClient={false}>
          {children}
        </FlagProvider>
      )}
      {!client && children}
    </>
  );
};
